/*
  c-product-subscription-loading.js

  定期購買 (ハックルベリー社) widget の DOM 挿入待ちでカート追加ボタンを一時 disabled に。
  widget が表示されるまでに「カートに追加」を押すと、アプリの selling_plan 選択 (定期購入)
  が反映されず単品としてカートに追加されてしまうのを防ぐ。

  動作:
    1. ページロード直後 → カート追加ボタンを disabled + .c-disabled-by-subscription-loading 付与
    2. .huckleberry-subscription-widget-container が DOM に出現 → disabled 解除
    3. 3 秒タイムアウト (= 通常商品で widget が永遠に出ない場合) → disabled 解除

  単一プラン / 複数プラン 共通動作:
    - 単一プラン商品: widget は CSS で非表示 (.c-single-subscription-plan) だが DOM は挿入される →
      MutationObserver で検知 → ready 発火
    - 複数プラン商品: widget が画面表示される (= ユーザー選択可能) → 同じく検知 → ready 発火

  ゲスト時 disable (c-disabled-by-warning) との共存:
    - 解除時に c-disabled-by-warning がある場合は disabled を維持 (ゲストは引き続き購入不可)
*/
(function () {
  /* 初期非活性化は CSS で `product-info:not(.c-subscription-ready) .product-form__submit`
     で行うため JS は widget 出現 / タイムアウト時に product-info 要素に
     c-subscription-ready 付与するだけ。
     Dawn の <body> には template-product class が付かない仕様のため、
     c-main-product.liquid の最外殻 <product-info id="MainProduct-..."> を制御対象とする。
     これにより JS load 遅延に関係なく HTML render 時点で非活性表示が反映される。 */
  var marked = false;
  function ready() {
    if (marked) return;
    marked = true;
    document.querySelectorAll('product-info').forEach(function (el) {
      el.classList.add('c-subscription-ready');
    });
  }

  function init() {
    /* 最低 1.25 秒待機を保証 (誤クリック防止):
       - widget 早期検出があっても 1.25 秒経過まで ready 発火しない
       - 1.25 秒経過後に widget あれば即 ready / なければ widget 出現待ち
       - 最大 3 秒で強制 ready (定期非対応商品向けタイムアウト) */
    var minDelayPassed = false;

    var observer = new MutationObserver(function () {
      if (minDelayPassed && document.querySelector('.huckleberry-subscription-widget-container')) {
        ready();
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // 最低 1.25 秒経過 → widget あれば ready / なければ continue 監視
    setTimeout(function () {
      minDelayPassed = true;
      if (document.querySelector('.huckleberry-subscription-widget-container')) {
        ready();
        observer.disconnect();
      }
    }, 1250);

    // 最大 3 秒タイムアウト (定期非対応商品 / widget が永遠に出ないケース)
    setTimeout(function () {
      ready();
      observer.disconnect();
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
